module.exports = __webpack_public_path__ + "img/gestaltra_logo_white.d2fa2d4a.png";